"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = require("react");
var _styles = require("@mui/material/styles");
var _Button = _interopRequireDefault(require("@mui/material/Button"));
var _colors = require("@mui/material/colors");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const ColorButton = (0, _styles.styled)(_Button.default)(({
  theme,
  variant
}) => ({
  ...(variant === "contained" && {
    backgroundColor: _colors.grey[200],
    border: `1.5px solid ${theme.palette.primary.main}`
  }),
  ...(variant === "outlined" && {
    borderColor: theme.palette.action.disabled
  }),
  color: theme.palette.text.primary,
  ...(variant === "contained" && {
    color: `rgba(0,0,0,0.87)`
  }),
  "&:hover": {
    backgroundColor: theme.palette.action.hover,
    ...(variant === "contained" && {
      backgroundColor: "#d5d5d5"
    }),
    ...(variant === "outlined" && {
      borderColor: theme.palette.action.disabled
    })
  }
}));
const DefaultColourButton = /*#__PURE__*/(0, _react.forwardRef)((props, ref) => {
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(ColorButton, {
    ref: ref,
    ...props,
    children: props.children
  });
});
DefaultColourButton.displayName = "DefaultColourButton";
var _default = exports.default = DefaultColourButton;